/** Discover → Functions (AUTO-8). Thin wrapper around <CatalogBrowsePage>. */

import { createFileRoute } from '@tanstack/react-router';
import { Code2 } from 'lucide-react';
import { CatalogBrowsePage } from '@/components/discover/catalog-browse-page';

export const Route = createFileRoute('/admin/discover/functions')({
  component: DiscoverFunctionsPage,
});

function DiscoverFunctionsPage() {
  return (
    <CatalogBrowsePage
      kind="function"
      title="Functions"
      description="Argus wrapper functions — sandboxed code (HTTP, SQL, Lua) that runs on the platform and is callable from agents. Tenant functions are authored in Studio → Functions."
      icon={Code2}
    />
  );
}
